/* eslint-disable */ import { memoEval, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const evoAffinity25GComponents = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'default', true).withEntity('EvoAffinity25G').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'EVO_AFFINITY_25G_100095_',
            dimensionUnit: 'inch'
        })))
];

//# sourceMappingURL=evo-affinity-25-g.js.map